module.exports = __webpack_public_path__ + "components/page-footer/static/mountain-forecast__logo--white-ece576c463f1c60fff9d30bc92323a3f.png";